import styled, { createGlobalStyle } from 'styled-components';

import { PageWrapper } from '../index.styles';

export const GlobalStyle = createGlobalStyle`
  ${PageWrapper} {
    background: var(--gray-light);
  }
`;

export const Section = styled.section`
  margin: 0 0 var(--gap) 0;
  text-align: left;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap);
`;
